// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1SS_e","row":"styles_row__FcR-G"};